import { request } from '@/utils/request';
import type { ApiResponse, WrappedItemsResult, WrappedResult } from './types';

const addressesApi = {
  getAll(params?: cyrian.api.addresses.GetParams): ApiResponse<WrappedItemsResult<cyrian.api.addresses.Address[]>> {
    return request({
      method: 'get',
      url: '/addresses',
      params,
    });
  },
  create(data: cyrian.api.addresses.AddressParams): ApiResponse<WrappedResult<cyrian.api.addresses.Address>> {
    return request({
      method: 'post',
      url: '/addresses',
      data,
    });
  },
  update(
    id: number,
    data: cyrian.api.addresses.AddressParams,
  ): ApiResponse<WrappedResult<cyrian.api.addresses.Address>> {
    return request({
      method: 'patch',
      url: `/addresses/${id}`,
      data,
    });
  },
  delete(id: number): ApiResponse<WrappedResult<any>> {
    return request({
      method: 'delete',
      url: `/addresses/${id}`,
    });
  },
};

export default addressesApi;
